import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/FeatureSection.module.css';

const FeatureSection = ({ id }) => {
  // 使用 i18n 的翻译钩子
  const { t } = useTranslation();

  // 功能亮点数据 - 使用翻译键
  const features = [
    { 
      title: t('features.privacy.title'), 
      desc: t('features.privacy.desc'), 
      icon: 'fas fa-shield-alt' 
    },
    { 
      title: t('features.unlimited.title'), 
      desc: t('features.unlimited.desc'), 
      icon: 'fas fa-bolt' 
    },
    { 
      title: t('features.lowPrice.title'), 
      desc: t('features.lowPrice.desc'), 
      icon: 'fas fa-dollar-sign' 
    },
    { 
      title: t('features.comprehensive.title'), 
      desc: t('features.comprehensive.desc'), 
      icon: 'fas fa-globe' 
    },
  ];

  return (
    <section id={id} className={styles.section}>
      <div className={styles.container}>
        <h2>{t('features.sectionTitle')}</h2>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <i className={feature.icon}></i>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;